import { Component } from '@angular/core';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-hstack-thumbs-per-entity',
  templateUrl: './hstack-thumbs-per-entity.component.html',
  styleUrl: './hstack-thumbs-per-entity.component.scss',
})
export class HstackThumbsPerEntityComponent {
  isLoading = true;

  label: any = {
    show: true,
    position: 'inside',
    formatter: (params) => {
      const total = this.series.reduce((acc, s) => {
        return acc + s.data[params.dataIndex];
      }, 0);
      console.log('total', total, params);
      const percentage = (params.value / total) * 100;
      return percentage >= 5 ? percentage.toFixed(0) + '%' : '';
    },
    fontWeight: 'bold',
    color: '#fff',
  };

  options: echarts.EChartsOption = {
    grid: { left: 165, right: 35, top: 40, bottom: 80 },
    stack: 'total',
    series: [
      {
        label: this.label,
      },
      {
        label: this.label,
      },
    ],
  };

  constructor(protected analyticsService: AnalyticsService) {
    this.analyticsService.hstackThumbsPerEntity$.subscribe((data) => {});
    this.analyticsService.isLoading$.subscribe((loading) => {
      this.isLoading = loading.includes('hstackThumbsPerEntity');
    });
    this.getChartData();
  }

  getChartData() {
    this.analyticsService.getHstackThumbsPerEntity().subscribe();
  }

  get series() {
    return this.analyticsService.hstackThumbsPerEntity$.value?.series;
  }

  get labels() {
    return this.analyticsService.hstackThumbsPerEntity$.value?.labels;
  }

  get entities() {
    return this.analyticsService.hstackThumbsPerEntity$.value?.entities;
  }
}
